import styled from "styled-components";

export const StyledGoToBackWrapper = styled.div`
  ${({pt}) => pt && `padding-top: ${pt}px`};
  ${({pb}) => pb && `padding-bottom: ${pb}px`};
  .icon-light-arrow-left {
    margin-right: 5px;
  }
  button, a {
    height: 45px;
  }
`;